(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["uv-atc-enhancer"] && !Shopify.designMode) return;
  try {
    (() => {
    const TAG = 'uv-atc-enhancer';
    if (customElements.get(TAG)) return;

    class UVATCEnhancer extends HTMLElement {
      connectedCallback() {
        if (this._uvConnected) return;
        this._uvConnected = true;
        this._frame = 0;
        this.install = this.install.bind(this);
        this.scheduleInstall = this.scheduleInstall.bind(this);
        this.onMutations = this.onMutations.bind(this);
        this.install();

        const root = this.sectionRoot;
        if ('MutationObserver' in window && root) {
          this.observer = new MutationObserver(this.onMutations);
          this.observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-uv-use-custom-font', 'style'] });
        }
      }

      disconnectedCallback() {
        this._uvConnected = false;
        if (this._frame) cancelAnimationFrame(this._frame);
        this._frame = 0;
        this.observer?.disconnect();
        this.observer = null;
        this.buttonResizeObserver?.disconnect();
        this.buttonResizeObserver = null;
        this._observedButton = null;
        this._lastObservedButtonWidth = null;
        this.removeDecorations();
      }

      get owner() { return this.dataset.owner || ''; }
      get sectionRoot() { return this.closest('product-information') || this.closest('.shopify-section') || null; }

      onMutations(mutations) {
        const relevantSelector =
          '.buy-buttons-block, product-form-component, [ref="productFormButtons"], .product-form-buttons, add-to-cart-component, [ref="addToCartButton"], [data-uv-atc-config-group]';

        const relevant = mutations.some((mutation) => {
          if (mutation.type === 'attributes') {
            return mutation.target instanceof Element && mutation.target.matches('[data-uv-atc-config-group]');
          }

          return Array.from(mutation.addedNodes).some((node) => {
            if (!(node instanceof Element)) return false;
            return node.matches(relevantSelector) || Boolean(node.querySelector?.(relevantSelector));
          });
        });

        if (relevant) this.scheduleInstall();
      }

      scheduleInstall() {
        if (!this._uvConnected) return;
        if (this._frame) cancelAnimationFrame(this._frame);
        this._frame = requestAnimationFrame(() => {
          this._frame = 0;
          this.install();
        });
      }

      findNativeTargets() {
        const root = this.sectionRoot;
        if (!root) return {};
        const component = root.querySelector(
          '.buy-buttons-block product-form-component add-to-cart-component'
        );
        if (!component) return {};
        const button = component.querySelector('[ref="addToCartButton"]');
        const buttonsContainer = component.closest('[ref="productFormButtons"], .product-form-buttons');
        if (!button || !buttonsContainer) return {};

        let atcBlockWrapper = component;
        while (atcBlockWrapper.parentElement && atcBlockWrapper.parentElement !== buttonsContainer) {
          atcBlockWrapper = atcBlockWrapper.parentElement;
        }
        if (atcBlockWrapper.parentElement !== buttonsContainer) return {};

        return { component, button, buttonsContainer, atcBlockWrapper };
      }

      cloneTemplate(selector) {
        const template = this.querySelector(selector);
        if (!(template instanceof HTMLTemplateElement)) return null;
        const node = template.content.firstElementChild;
        return node ? node.cloneNode(true) : null;
      }


      applyButtonFont(button) {
        if (!(button instanceof HTMLElement)) return;

        const config = this.querySelector('[data-uv-atc-config-group="button"]');
        const labelNodes = button.querySelectorAll(
          '.add-to-cart-text, .add-to-cart-text__content, .add-to-cart-text__content > span, .add-to-cart__added'
        );

        const clearCustomFont = () => {
          button.style.removeProperty('--button-font-family-primary');
          button.style.removeProperty('--font-paragraph--family');
          button.style.removeProperty('--font-paragraph--style');
          button.style.removeProperty('font-family');
          button.style.removeProperty('font-style');
          labelNodes.forEach((node) => {
            node.style.removeProperty('font-family');
            node.style.removeProperty('font-style');
          });
        };

        if (!(config instanceof HTMLElement) || config.dataset.uvUseCustomFont !== 'true') {
          clearCustomFont();
          return;
        }

        const configStyle = getComputedStyle(config);
        const family = configStyle.getPropertyValue('--uv-selected-button-font-family').trim();
        const style = configStyle.getPropertyValue('--uv-selected-button-font-style').trim() || 'normal';
        if (!family) {
          clearCustomFont();
          return;
        }

        /* Inline !important is intentional here. Horizon assigns .button to its global
           --button-font-family-primary variable; applying the merchant-selected Shopify
           font directly to the native button and its animated text spans guarantees that
           no later theme rule can silently restore the global button family. */
        button.style.setProperty('--button-font-family-primary', family);
        button.style.setProperty('--font-paragraph--family', family);
        button.style.setProperty('--font-paragraph--style', style);
        button.style.setProperty('font-family', family, 'important');
        button.style.setProperty('font-style', style, 'important');

        labelNodes.forEach((node) => {
          node.style.setProperty('font-family', family, 'important');
          node.style.setProperty('font-style', style, 'important');
        });
      }

      fitButtonText(button) {
        if (!(button instanceof HTMLElement) || !button.isConnected) return;

        /* Keep the merchant-selected size as the maximum and shrink only when needed. */
        button.style.removeProperty('--uv-atc-fit-font-size');

        const styles = getComputedStyle(button);
        const baseSize = parseFloat(styles.getPropertyValue('--uv-atc-base-font-size')) || parseFloat(styles.fontSize) || 16;
        const minSize = Math.min(12, baseSize);

        button.style.setProperty('--uv-atc-fit-font-size', `${baseSize}px`);
        if (button.scrollWidth <= button.clientWidth + 1) return;

        let low = minSize;
        let high = baseSize;
        let best = minSize;

        for (let i = 0; i < 8; i += 1) {
          const mid = (low + high) / 2;
          button.style.setProperty('--uv-atc-fit-font-size', `${mid}px`);

          if (button.scrollWidth <= button.clientWidth + 1) {
            best = mid;
            low = mid;
          } else {
            high = mid;
          }
        }

        button.style.setProperty('--uv-atc-fit-font-size', `${Math.floor(best * 10) / 10}px`);
      }

      observeButtonSize(button) {
        if (!('ResizeObserver' in window) || !(button instanceof HTMLElement)) return;
        if (this._observedButton === button) return;

        this.buttonResizeObserver?.disconnect();
        this._observedButton = button;
        this._lastObservedButtonWidth = button.clientWidth;
        this.buttonResizeObserver = new ResizeObserver(() => {
          const width = button.clientWidth;
          if (Math.abs(width - (this._lastObservedButtonWidth ?? width)) < 0.5) return;
          this._lastObservedButtonWidth = width;
          this.fitButtonText(button);
        });
        this.buttonResizeObserver.observe(button);
      }

      install() {
        if (!this._uvConnected || !this.owner) return;
        const { component, button, buttonsContainer, atcBlockWrapper } = this.findNativeTargets();
        if (!component || !button || !buttonsContainer || !atcBlockWrapper) return;

        if (button.dataset.uvAtcRestCaptured !== 'true') {
          const restStyle = getComputedStyle(button);
          button.style.setProperty('--uv-atc-rest-bg', restStyle.backgroundColor);
          button.style.setProperty('--uv-atc-rest-color', restStyle.color);
          button.style.setProperty('--uv-atc-rest-border', restStyle.borderColor);
          button.dataset.uvAtcRestCaptured = 'true';
        }

        button.setAttribute('data-uv-atc-button-owner', this.owner);
        atcBlockWrapper.setAttribute('data-uv-atc-wrapper-owner', this.owner);
        this.applyButtonFont(button);
        this.observeButtonSize(button);
        this.fitButtonText(button);

        if (document.fonts?.ready) {
          document.fonts.ready.then(() => {
            if (this._uvConnected && button.isConnected) {
              this.applyButtonFont(button);
              this.fitButtonText(button);
            }
          });
        }

        let top = atcBlockWrapper.querySelector(`:scope > [data-uv-atc-trust-owner="${CSS.escape(this.owner)}"]`);
        if (!top) {
          top = this.cloneTemplate('[data-uv-top-template]');
          if (top) atcBlockWrapper.insertBefore(top, component);
        } else if (top.nextElementSibling !== component) {
          atcBlockWrapper.insertBefore(top, component);
        }

        let bottom = atcBlockWrapper.querySelector(`:scope > [data-uv-atc-guarantee-owner="${CSS.escape(this.owner)}"]`);
        if (!bottom) {
          bottom = this.cloneTemplate('[data-uv-bottom-template]');
          if (bottom) component.insertAdjacentElement('afterend', bottom);
        } else if (component.nextElementSibling !== bottom) {
          component.insertAdjacentElement('afterend', bottom);
        }
      }

      removeDecorations() {
        const root = this.sectionRoot;
        if (!root || !this.owner) return;
        root.querySelectorAll(`[data-uv-atc-trust-owner="${CSS.escape(this.owner)}"], [data-uv-atc-guarantee-owner="${CSS.escape(this.owner)}"]`).forEach((node) => node.remove());
        root.querySelectorAll(`[data-uv-atc-button-owner="${CSS.escape(this.owner)}"]`).forEach((button) => {
          button.removeAttribute('data-uv-atc-button-owner');
          button.removeAttribute('data-uv-atc-rest-captured');
          button.style.removeProperty('--uv-atc-rest-bg');
          button.style.removeProperty('--uv-atc-rest-color');
          button.style.removeProperty('--uv-atc-rest-border');
          button.style.removeProperty('--uv-atc-fit-font-size');
          button.style.removeProperty('--button-font-family-primary');
          button.style.removeProperty('--font-paragraph--family');
          button.style.removeProperty('--font-paragraph--style');
          button.style.removeProperty('font-family');
          button.style.removeProperty('font-style');
          button.querySelectorAll('.add-to-cart-text, .add-to-cart-text__content, .add-to-cart-text__content > span, .add-to-cart__added').forEach((node) => {
            node.style.removeProperty('font-family');
            node.style.removeProperty('font-style');
          });
        });
        root.querySelectorAll(`[data-uv-atc-wrapper-owner="${CSS.escape(this.owner)}"]`).forEach((wrapper) => wrapper.removeAttribute('data-uv-atc-wrapper-owner'));
      }
    }

    customElements.define(TAG, UVATCEnhancer);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["uv-premium-bundle"] && !Shopify.designMode) return;
  try {
    (() => {
    const TAG = 'uv-premium-bundle';

    if (customElements.get(TAG)) return;

    class UVPremiumBundle extends HTMLElement {
      connectedCallback() {
        this.cleanup();

        if (this.dataset.compact !== 'true') return;

        this.viewport = this.querySelector('[data-compact-viewport]');
        this.deals = this.querySelector('[data-deals]');
        if (!this.viewport || !this.deals) return;

        this.minSize = Math.max(6, Number(this.dataset.compactMin) || 8);
        this.maxSize = Math.max(this.minSize, Number(this.dataset.compactMax) || 14);
        this.frame = 0;

        this.fit = this.fit.bind(this);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.fit);
          this.resizeObserver.observe(this.viewport);
        } else {
          window.addEventListener('resize', this.fit, { passive: true });
        }

        if (document.fonts?.ready) {
          document.fonts.ready.then(() => {
            if (this.isConnected) this.fit();
          });
        }

        this.fit();
      }

      disconnectedCallback() {
        this.cleanup();
      }

      cleanup() {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;

        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
          this.resizeObserver = null;
        }

        window.removeEventListener('resize', this.fit);
      }

      setFontSize(size) {
        this.deals?.style.setProperty('--uvb-compact-font-size', `${size.toFixed(2)}px`);
      }

      measureFits() {
        if (!this.viewport || !this.deals) return true;
        return this.deals.scrollWidth <= this.viewport.clientWidth + 0.5;
      }

      fitAtCurrentTightness() {
        let low = this.minSize;
        let high = this.maxSize;

        this.setFontSize(high);
        this.deals.style.setProperty('--uvb-compact-scale', '1');

        if (this.measureFits()) return true;

        for (let step = 0; step < 10; step += 1) {
          const middle = (low + high) / 2;
          this.setFontSize(middle);

          if (this.measureFits()) {
            low = middle;
          } else {
            high = middle;
          }
        }

        this.setFontSize(low);
        return this.measureFits();
      }

      fit() {
        if (!this.viewport || !this.deals) return;

        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          if (!this.isConnected || !this.viewport || !this.deals) return;

          this.deals.classList.remove('uv-premium-bundle__deals--tight');
          this.deals.style.setProperty('--uvb-compact-scale', '1');

          let fits = this.fitAtCurrentTightness();

          if (!fits) {
            this.deals.classList.add('uv-premium-bundle__deals--tight');
            fits = this.fitAtCurrentTightness();
          }

          if (!fits) {
            const available = this.viewport.clientWidth;
            const required = this.deals.scrollWidth;
            const scale = required > 0 ? Math.min(1, available / required) : 1;
            this.deals.style.setProperty('--uvb-compact-scale', String(Math.max(0.01, scale)));
          }
        });
      }
    }

    customElements.define(TAG, UVPremiumBundle);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["uv-seo-geo-accordion"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('uv-seo-geo-accordion')) return;

    class UVSeoGeoAccordion extends HTMLElement {
      connectedCallback() {
        this._controller?.abort();
        this._controller = new AbortController();
        const { signal } = this._controller;

        this.addEventListener('click', this._onClick, { signal });

        this.querySelectorAll('dialog').forEach((dialog) => {
          dialog.addEventListener('click', this._onDialogBackdropClick, { signal });
          dialog.addEventListener('close', this._onDialogClosed, { signal });
          dialog.addEventListener('cancel', this._onDialogCancel, { signal });
        });
      }

      disconnectedCallback() {
        this._controller?.abort();
        this.querySelectorAll('dialog[open]').forEach((dialog) => {
          try { dialog.close(); } catch (_) {}
        });
        this._syncBodyLock();
      }

      _onClick = (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        const openTrigger = target.closest('[data-uv-modal-open]');
        if (openTrigger && this.contains(openTrigger)) {
          event.preventDefault();
          this._openDialog(openTrigger);
          return;
        }

        const closeTrigger = target.closest('[data-uv-modal-close]');
        if (closeTrigger && this.contains(closeTrigger)) {
          event.preventDefault();
          const dialog = closeTrigger.closest('dialog');
          if (dialog) this._closeDialog(dialog);
          return;
        }

        const unitTrigger = target.closest('.sc-toggle-btn[data-unit]');
        if (unitTrigger && this.contains(unitTrigger)) {
          event.preventDefault();
          const dialog = unitTrigger.closest('dialog');
          if (dialog) this._setSizeChartUnit(dialog, unitTrigger.dataset.unit);
        }
      };

      _openDialog(trigger) {
        const dialogId = trigger.getAttribute('data-uv-modal-open');
        if (!dialogId) return;

        const dialog = this.querySelector(`#${CSS.escape(dialogId)}`);
        if (!(dialog instanceof HTMLDialogElement)) return;

        dialog._uvReturnFocus = trigger;

        if (!dialog.open) {
          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }
        }

        document.body.classList.add('uv-sga-dialog-open');
        this._initializeSizeChart(dialog);
      }

      _closeDialog(dialog) {
        if (!(dialog instanceof HTMLDialogElement)) return;

        if (dialog.open && typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
          this._onDialogClosed({ currentTarget: dialog });
        }
      }

      _onDialogBackdropClick = (event) => {
        if (event.target === event.currentTarget) {
          this._closeDialog(event.currentTarget);
        }
      };

      _onDialogCancel = () => {
        requestAnimationFrame(() => this._syncBodyLock());
      };

      _onDialogClosed = (event) => {
        const dialog = event.currentTarget;
        const returnFocus = dialog?._uvReturnFocus;
        this._syncBodyLock();

        if (returnFocus instanceof HTMLElement && returnFocus.isConnected) {
          returnFocus.focus({ preventScroll: true });
        }
      };

      _syncBodyLock() {
        if (!document.querySelector('uv-seo-geo-accordion dialog[open]')) {
          document.body.classList.remove('uv-sga-dialog-open');
        }
      }

      _initializeSizeChart(dialog) {
        const active = dialog.querySelector('.sc-toggle-btn.active[data-unit]');
        const first = dialog.querySelector('.sc-toggle-btn[data-unit]');
        const selected = active || first;

        if (selected) {
          this._setSizeChartUnit(dialog, selected.dataset.unit);
        }
      }

      _setSizeChartUnit(dialog, unit) {
        if (unit !== 'cm' && unit !== 'in') return;

        dialog.querySelectorAll('.sc-toggle-btn[data-unit]').forEach((button) => {
          const isActive = button.dataset.unit === unit;
          button.classList.toggle('active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        dialog.querySelectorAll('tbody tr[data-chest], tbody tr[data-length]').forEach((row) => {
          const chestRaw = row.getAttribute('data-chest');
          const lengthRaw = row.getAttribute('data-length');
          const chest = Number.parseFloat(chestRaw);
          const length = Number.parseFloat(lengthRaw);
          const chestCell = row.querySelector('.val-chest');
          const lengthCell = row.querySelector('.val-len');

          if (chestCell && Number.isFinite(chest)) {
            chestCell.textContent = unit === 'cm' ? (chest * 2.54).toFixed(1) : chestRaw;
          }

          if (lengthCell && Number.isFinite(length)) {
            lengthCell.textContent = unit === 'cm' ? (length * 2.54).toFixed(1) : lengthRaw;
          }
        });
      }
    }

    customElements.define('uv-seo-geo-accordion', UVSeoGeoAccordion);
  })();
  } catch(e) { console.error(e); }
})();

})();
